<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex flex-wrap">
				<el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small" v-model="planDate" @change="handleSearch()"
					type="daterange" :picker-options="pickerOptions" :editable="false" :clearable="false" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<el-input v-model.trim="searchFrom.agentName" class="w190 ml10" size="small" placeholder="客商" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<el-input v-model.trim="searchFrom.routeName" class="w190 ml10" size="small" placeholder="路线" @keyup.enter.native="handleSearch"
					maxlength="16" clearable>
				</el-input>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch()" alt="">
			</div>
			<div>
				<img class="icon-img ml7" src="@/assets/images/delete.png" v-if="isEdit&&roleType" @click="deleteRow" title="删除" alt="">
			</div>
		</div>
		<div class="table-container">
			<div v-if="tableData.length>0">
				<el-table class="mgrTable" ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :infinite-scroll-distance="50"
					:infinite-scroll-immediate="false" :data="tableData" :height="height" :cell-style="cellStyle"
					:row-class-name="tabRowClassName"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					:row-key="(row) => { return row.dataKey}" @selection-change="handleSelectionChange" border
					style="width: 100%" @cell-click="editRow" >
					<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
					</el-table-column>
					<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index" :prop="value.prop" sortable :column-key="value.prop" :fixed="value.fix"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row[value.prop]}}
						</template>
					</el-table-column>
				</el-table>
				
			</div>
			<el-empty v-else :style="{height:height+'px'}" description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
					<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png"
						@click="download" title="导出" alt="">
				</div>
		</div>
		<stockEdit ref="stockEdit"></stockEdit>
	</div>
</template>

<script>
	import stockEdit from './components/stock-edit.vue'
	import {dateFormat} from '@/utils/common'
	import { hasPermission } from '@/utils/permission'
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		name:'agentStock',
		components: {
			stockEdit
		},
		data() {
			return {
				searchFrom: {
					agentName: "",
					routeName:"",
				},
				tableData: [],
				titles: [],
				multipleSelection: [],
				pageNo: 1,
				pageSize: 40,
				height: 500,
				planDate: [],
				infiniteFlag: false,
				isEdit:false,
				roleType:window.sessionStorage.getItem("roleType")==2?false:true,
				totalPage:"",
				totalCount:"",
				currentNo:"",
				min: '',
				pickerOptions: {
					onPick: ({minDate, maxDate}) => {
						this.min = minDate && minDate.getTime() // 将第一个选中的日期赋值给 this.min
						// 如果选择了时间段，则清空 this.min
						if(maxDate){
							this.min = ''
						}
					},
					disabledDate: (time) => {
						let oneMonths = 30*24*60*60*1000
						let minDate = this.min - oneMonths
						let maxDate = this.min + oneMonths
						if (this.min !== ""){
							return  time.getTime() > maxDate || time.getTime() < minDate 
						} 
					}
				},

			}
		},
		created() {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
			this.planDate=[dateFormat(start), dateFormat(end)]
			this.getList()
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		mounted() {
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 126 - height;
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
// 搜索
			handleSearch() {
				this.infiniteFlag = false;
				this.pageNo = 1
				this.$nextTick(() => {
					this.getList()
				})
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
			},
			// 删除
			deleteRow() {
				let that = this;
				if (that.multipleSelection.length == 0) {
					that.$message.error('请先选择需要删除的数据');
					return
				}
				let checkIds = [];
				that.multipleSelection.forEach(item => {
					checkIds.push(item.dataKey);
				})
				that.$confirm('是否确认删除？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
							"agentDeleteStock",
							false, {
								checkIds: checkIds,
							}
						)
						.then((res) => {
							if (res) {
								that.$message.success("删除成功");
								that.handleSearch();
							}
						})
				}).catch(() => {});
			},

			// 获取列表
			getList(type) {
			if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"agentStockList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							dateStart: that.planDate?that.planDate[0]:"",
							dateEnd: that.planDate?that.planDate[1]:"",
							agentName: that.searchFrom.agentName,
							routeName: that.searchFrom.routeName,
						}
					)
					.then((res) => {
						if(res.data){
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
						}
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.tableDatas || []);
							that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
						} else {
							if (res.data && res.data.tableDatas.length > 0) {
								that.titles = res.data.titles
								that.tableData = res.data.tableDatas
								that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
							} else {
								that.titles = []
								that.tableData = []
								that.totalPage=0
								that.totalCount=0
								that.currentNo = 0
							}
						}
						that.titles  = that.titles.map((item, index) => { 
									return { 
										title: item.title, 
										prop: 'tr' + index,
										maxWidth:item.maxWidth, 
										fix:item.fix==1?true:false
									} 
								})
						that.tableData.forEach(item => {
							for (let i = 0; i < that.titles.length; i++) {
								item['tr' + i] = item.datas[i] || ''
							}
						})
					})
			},


			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 点击列
			// 查看/编辑
			editRow(row, column, cell, event) {
				if (column.label == this.titles[2].title) {
					this.$refs.stockEdit.init(row)
				} else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			// 导出
			download() {
				let that = this;
				// if (that.multipleSelection.length == 0) {
				// 	that.$message.error('请先选择需要导出的数据');
				// 	return
				// }
				let checkIds = [];
				that.multipleSelection.forEach(item => {
					checkIds.push(item.dataKey);
				})
				that.$request.post(
						"agentExportStock",
						true, {
							pageNo: 1,
							pageSize: 50000,
							checkIds: checkIds,
							dateStart: that.planDate?that.planDate[0]:"",
							dateEnd: that.planDate?that.planDate[1]:"",
							agentName: that.searchFrom.agentName,
							routeName: that.searchFrom.routeName,
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},
			//

		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

	.operation-box {
		min-width: 185px;
	}

	.w190 {
		width: 150px !important;
	}

</style>
